import React from 'react';
import { ChevronDown, Check } from 'lucide-react';
interface HeroSectionProps {
  imageUrl: string;
}
export function HeroSection({
  imageUrl
}: HeroSectionProps) {
  const scrollToPurchase = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto text-center" data-id="element-94">
      <div className="absolute inset-0 bg-gradient-to-b from-green-900/20 to-transparent pointer-events-none" data-id="element-95" />

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-96">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black tracking-tight mb-10 text-[#faf5e8] leading-tight" data-id="element-97">
          Si tu rendimiento no aparece en los partidos, el{' '}
          <span className="text-[#c8e6c9] border-b-4 border-[#c8e6c9]" data-id="element-98">
            problema no es tu esfuerzo
          </span>
        </h1>

        <div className="relative mx-auto cursor-pointer transform transition-transform hover:scale-105 duration-300 mb-10" onClick={scrollToPurchase} style={{
        width: '80%',
        maxWidth: '640px'
      }} data-id="element-99">
          <div className="absolute inset-0 bg-[#4caf50] blur-[100px] opacity-15 rounded-full" data-id="element-100" />
          <img src={imageUrl} alt="Hockey Pro System" className="relative z-10 w-full h-auto drop-shadow-2xl mx-auto" data-id="element-101" />
        </div>

        <p className="text-lg md:text-xl text-[#d4d0c4] mb-10 font-medium leading-relaxed max-w-2xl mx-auto" data-id="element-102">
          Para jugadoras que entrenan mucho, pero sienten que en los partidos
          siguen llegando tarde, dudando o perdiendo jugadas importantes.
        </p>

        <div className="flex flex-col items-center" data-id="element-103">
          <button onClick={scrollToPurchase} className="bg-[#2e7d32] hover:bg-[#388e3c] text-[#faf5e8] font-heading font-bold text-xl md:text-2xl py-4 px-10 rounded-full shadow-[0_0_20px_rgba(46,125,50,0.4)] transition-all transform hover:scale-105 hover:shadow-[0_0_30px_rgba(46,125,50,0.6)] uppercase tracking-wide" data-id="element-104">
            Quiero dejar de improvisar
          </button>

          <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs md:text-sm text-[#a8c5a8] font-medium" data-id="element-105">
            <span className="inline-flex items-center gap-1.5" data-id="element-106">
              <Check className="w-3.5 h-3.5 text-[#c8e6c9]" strokeWidth={3} data-id="element-107" />
              Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-108">
              <Check className="w-3.5 h-3.5 text-[#c8e6c9]" strokeWidth={3} data-id="element-109" />6
              capítulos + bonos
            </span>
            <span className="inline-flex items-center gap-1.5" data-id="element-110">
              <Check className="w-3.5 h-3.5 text-[#c8e6c9]" strokeWidth={3} data-id="element-111" />
              Atacantes y defensoras
            </span>
          </div>

          <p className="mt-6 text-xs text-[#a8c5a8] flex items-center gap-2" data-id="element-112">
            <ChevronDown className="w-3.5 h-3.5 animate-bounce" data-id="element-113" />
            Deslizá para ver más
            <ChevronDown className="w-3.5 h-3.5 animate-bounce" data-id="element-114" />
          </p>
        </div>
      </div>
    </section>;
}